module.exports = __webpack_public_path__ + "img/Infinity-1s-200px.8cb17c34.svg";